export const displayNames: { [key: string]: string } = {
    facility: 'Facility',
    area: 'Area',
    isEquipmentSafeguard: 'Is Equipment Safeguard',
    facilityOwner: "Facility Owner",
    taskFrequency: 'Task Frequency',
    percentOverdue: 'Percent Overdue',
    consequenceRanking: 'Consequence Ranking',
    standbyMode: 'Standby Mode',
    assignedManagementAuthorizationLevel: 'Assigned Management Authorization Level',
    justification: 'Justification (in case of non-HCE)',
    additionalInformationForEquipmentEN: 'Additional Information For Equipment [EN]',
    additionalInformationForEquipmentRU: 'Additional Information For Equipment [RU]',
    additionalInformationForEquipmentKZ: 'Additional Information For Equipment [KZ]',
};

